export default "__VITE_ASSET__C0W5dLJS__"